import { MemberEligibilityInfo } from "@/App/types";

import capRxLogoWhite from "@/App/components/MemberCard/Assets/caprx-logo-web-white.svg?url";

import "../NonDiscountCard/MemberCard.scss";
import "./DiscountCard.scss";

interface Props {
  memberEligibilityInfo: MemberEligibilityInfo;
}

export const DiscountCardFront: React.FC<Props> = (props: Props) => {
  const { memberEligibilityInfo } = props;

  // plan group_number is a string of group_numbers split by commas
  let group_number = memberEligibilityInfo.plan.group_number;

  // order of precedence group > plan account > plan
  if (memberEligibilityInfo.group.group_number) {
    group_number = memberEligibilityInfo.group.group_number.split(",")[0];
  } else if (memberEligibilityInfo.plan_account.group_number) {
    group_number = memberEligibilityInfo.plan_account.group_number.split(",")[0];
  } else {
    group_number = group_number ? group_number.split(",")[0] : "TBD";
  }

  return (
    <div className="cv2">
      <div className="discount-id-card discount-id-card-front">
        <div className={`discount-id-card-container discount-id-card-front`}>
          <div className="discount-id-card-header">
            <div className="discount-id-card-header-text">
              <div className="discount-id-card-header-info">Because You Deserve The Best Prices.</div>
              <div className="discount-id-card-header-title">That is the Capital Rx Advantage.</div>
            </div>
          </div>
          <div className="discount-id-card-info">
            <div className="discount-id-card-info-container">
              <div className="discount-id-card-info left">
                <div>
                  <span className="discount-id-card-info-label">Rx BIN:</span> {memberEligibilityInfo.plan.bin_number}
                </div>
                <div>
                  <span className="discount-id-card-info-label">Group Number:</span> {group_number}
                </div>
                <div>
                  <span className="discount-id-card-info-label">PCN:</span> {memberEligibilityInfo.plan.processor_control_number}
                </div>
                <div>
                  <span className="discount-id-card-info-label">Member ID:</span> {memberEligibilityInfo.member.external_member_id}
                </div>
              </div>
              <div className="discount-id-card-info right">
                <img src={capRxLogoWhite} className="discount-id-card-logo" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
